import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export default function Header({ children }: Props): JSX.Element {
  return (
    <header>
      {children}
      <style jsx>{`
        header {
          width: 80%;
          margin-bottom: 3em;
        }

        header :global(h1) {
          color: black;
          font-size: 25px !important;
          line-height: 26px;
          margin-bottom: 0;
        }
      `}</style>
    </header>
  );
}
